import { Controller } from "stimulus"

const GA_TAG_ID = "AW-347129426"
const COOKIE_NAME = "cookie_consent"

export default class extends Controller {
  static targets = ["modal"]

  open(event) {
    event.preventDefault()
    this.modalTarget.style.display = "flex"
  }

  close() {
    this.modalTarget.style.display = "none"
  }

  accept() {
    this._setConsent("accepted")
    this._injectGA()
    this.close()
  }

  decline() {
    this._setConsent("declined")
    this.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  _getConsent() {
    return document.cookie.split("; ").find(row => row.startsWith(COOKIE_NAME + "="))
  }

  _setConsent(value) {
    document.cookie = `${COOKIE_NAME}=${value}; max-age=31536000; path=/; SameSite=Lax`
    // Also hide the banner if it's visible
    const banner = document.querySelector("[data-controller='cookie-consent']")
    if (banner) banner.style.display = "none"
  }

  _injectGA() {
    if (window.gtag) return
    const script = document.createElement("script")
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TAG_ID}`
    document.head.appendChild(script)

    window.dataLayer = window.dataLayer || []
    function gtag() { window.dataLayer.push(arguments) }
    window.gtag = gtag
    gtag("js", new Date())
    gtag("config", GA_TAG_ID)
  }
}
